<template>
  <!-- 注意：以下编号商品重新申请过标签，请注意 -->
  <div>
    <el-dialog :visible.sync="dialogVisible" width="450px" center :close-on-click-modal="false">
      <div class="content">
        <h3>注意：以下编号商品重新申请过标签，请注意</h3>
        <div class="row" v-for="(item, index) in list" :key="index">
          <div class="label">NO:{{ item.NO }}</div>
          <div class="order">{{ item.order_sn }}</div>
          <div class="fan">{{ item.sorting }}番</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="dialogVisible = false">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {

  },
  data() {
    return {
      dialogVisible: false,
      list: [],
      name: ''// name空的显示全部 
    };
  },
  created() {
    // this.$api.
  },
  methods: {
    getList(list) {
      this.list = []
      list.forEach(item => {
        item.porder_detail_tag.forEach(tag => {
          if (tag.porder_detail_tag_print != false) {
            this.list.push(item)
          }
        })
      })
      // 数组去重
      // var hash = {};
      // this.list = this.list.reduce(function (item, next) {
      //   hash[next.order_sn]
      //     ? ""
      //     : (hash[next.order_sn] = true && item.push(next));

      //   return item;
      // }, []);
      if (this.list != false) {
        this.dialogVisible = true
      }

    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  margin: 0 20px;

  .row {
    display: flex;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 15px;
  }

  h3 {
    color: red;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .label {
    font-weight: 600;
  }

  .order {
    margin: 0 20px;
  }
}
</style>
